export default "__VITE_ASSET__6634e8b5__"